import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import CloseButton from 'shared/components/buttons/Close';
import styles from './Alert.module.scss';

const Alert = ({ variant, canClose, className, onClose, noTopRadius, children }) => {
  const [closed, setClosed] = useState(false);
  const toggleClosed = () => setClosed((prev) => {
    if (!prev) {
      onClose();
    }
    return !prev;
  });

  return (
    <div className={cn(
      styles.alert,
      styles[variant], {
        [styles.closed]: closed,
        [styles.noTopRadius]: noTopRadius
      },
      className
    )}
    >
      <span>{children}</span>
      {canClose && (
        <CloseButton onClick={toggleClosed} className={styles.closeButton} />
      )}
    </div>
  );
};

Alert.propTypes = {
  className: PropTypes.string,
  canClose: PropTypes.bool,
  noTopRadius: PropTypes.bool,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']),
  onClose: PropTypes.func,
};

Alert.defaultProps = {
  className: null,
  variant: 'info',
  canClose: true,
  noTopRadius: false,
  onClose() {},
};

export default Alert;
